const Spinnerable = {
  handleInputChange(beforeCallback, afterCallback) {
    return e => {
      (beforeCallback || _.noop).call(this, e);
      this.showSpinner();
      setTimeout(() => {
        (afterCallback || _.noop).call(this);
        this.renderChart();
        this.hideSpinner();
      }
        , 0);
    };
  },
  showSpinner() {
    this.chartContainer.html('');
    if ((this._spinner == null)) {
      this._spinner = $('<div>').addClass('spinner dark charts-spinner').appendTo(this.container);
    }
  },
  hideSpinner() {
    if (this._spinner != null) {
      this._spinner.remove();
      delete this._spinner;
    }
  }
};

export default Spinnerable;